import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import Quote from "@/pages/QuoteForm";
import TrackOrder from "@/pages/TrackOrder";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import DashboardPage from "@/admin/DashboardPage";
import ProductsPage from "@/admin/ProductsPage";
import CategoriesPage from "@/admin/CategoriesPage";
import OrdersPage from "@/admin/OrdersPage";
import OrderDetail from "@/admin/OrderDetail";
import QuotesPage from "@/admin/QuotesPage";
import QuoteDetail from "@/admin/QuoteDetail";
import FormBuilderPage from "@/admin/FormBuilderPage";
import CustomersPage from "@/admin/CustomersPage";
import PaymentsPage from "@/admin/PaymentsPage";
import ShippingPage from "@/admin/ShippingPage";
import SettingsPage from "@/admin/SettingsPage";
import AuditPage from "@/admin/AuditPage";

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--brand-background)" }}>
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <CartDrawer />
    </div>
  );
}

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/catalogo" element={<Layout><Catalog /></Layout>} />
          <Route path="/catalogo/:category" element={<Layout><Catalog /></Layout>} />
          <Route path="/catalogo/:category/:subcategory" element={<Layout><Catalog /></Layout>} />
          <Route path="/producto/:id" element={<Layout><ProductDetail /></Layout>} />
          <Route path="/checkout" element={<Layout><Checkout /></Layout>} />
          <Route path="/cotizacion" element={<Layout><Quote /></Layout>} />
          <Route path="/seguimiento" element={<Layout><TrackOrder /></Layout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="pedidos" element={<OrdersPage />} />
            <Route path="pedidos/:id" element={<OrderDetail />} />
            <Route path="cotizaciones" element={<QuotesPage />} />
            <Route path="cotizaciones/:id" element={<QuoteDetail />} />
            <Route path="formulario" element={<FormBuilderPage />} />
            <Route path="productos" element={<ProductsPage />} />
            <Route path="categorias" element={<CategoriesPage />} />
            <Route path="clientes" element={<CustomersPage />} />
            <Route path="pagos" element={<PaymentsPage />} />
            <Route path="envios" element={<ShippingPage />} />
            <Route path="configuracion" element={<SettingsPage />} />
            <Route path="historial" element={<AuditPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </StoreProvider>
  );
}

export default App;
